import snakecaseKeys from 'snakecase-keys';
import { toChainFormat } from '@injectivelabs/utils';
import { CosmosStakingV1Beta1Tx, CosmosStakingV1Beta1Staking, } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
import { numberToCosmosSdkDecString } from '../../../../utils/numbers.js';
/**
 * @category Messages
 */
export default class MsgEditValidator extends MsgBase {
    static fromJSON(params) {
        return new MsgEditValidator(params);
    }
    toProto() {
        const { params } = this;
        const message = CosmosStakingV1Beta1Tx.MsgEditValidator.create();
        if (params.description) {
            const description = CosmosStakingV1Beta1Staking.Description.create();
            if (params.description.moniker) {
                description.moniker = params.description.moniker;
            }
            if (params.description.identity) {
                description.identity = params.description.identity;
            }
            if (params.description.website) {
                description.website = params.description.website;
            }
            if (params.description.securityContact) {
                description.securityContact = params.description.securityContact;
            }
            if (params.description.details) {
                description.details = params.description.details;
            }
            message.description = description;
        }
        message.validatorAddress = params.validatorAddress;
        if (params.commissionRate) {
            message.commissionRate = params.commissionRate;
        }
        if (params.minSelfDelegation) {
            message.minSelfDelegation = params.minSelfDelegation;
        }
        return CosmosStakingV1Beta1Tx.MsgEditValidator.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/cosmos.staking.v1beta1.MsgEditValidator',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'cosmos-sdk/MsgEditValidator',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/cosmos.staking.v1beta1.MsgEditValidator',
            ...value,
        };
    }
    toEip712() {
        const { type, value } = this.toAmino();
        const messageAdjusted = {
            ...value,
            commission_rate: toChainFormat(value.commission_rate).toFixed(),
        };
        return {
            type,
            value: messageAdjusted,
        };
    }
    toEip712V2() {
        const web3gw = this.toWeb3Gw();
        const messageAdjusted = {
            ...web3gw,
            commission_rate: numberToCosmosSdkDecString(web3gw.commission_rate),
        };
        return messageAdjusted;
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/cosmos.staking.v1beta1.MsgEditValidator',
            message: proto,
        };
    }
    toBinary() {
        return CosmosStakingV1Beta1Tx.MsgEditValidator.encode(this.toProto()).finish();
    }
}
